import { render, staticRenderFns } from "./Spells.vue?vue&type=template&id=20ef9a40&scoped=true&"
import script from "./Spells.vue?vue&type=script&lang=js&"
export * from "./Spells.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20ef9a40",
  null
  
)

export default component.exports